// RequireEstate.tsx

import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import EstateSelectorModal from '../estates/estateselector';
import { useGlobalContext } from '../../store/GlobalContext';

interface RequireEstateProps {
  children: JSX.Element;
}

const estateSpecificRoutes = [
  '/assets',
  '/cashflows',
  '/family-tree',
  '/liabilities',
  '/cashflow',
  '/probate-docs',
  '/family-jewels',
  '/filings',
  // Add other estate-specific routes here
];

const RequireEstate: React.FC<RequireEstateProps> = ({ children }) => {
  const location = useLocation();
  const { selectedEstate, loading } = useGlobalContext();
  const [modalVisible, setModalVisible] = useState<boolean>(false);

  useEffect(() => {
    if (loading) return; // Wait until loading is complete
    const isEstateRoute = estateSpecificRoutes.some((route) => location.pathname.startsWith(route));
    if (isEstateRoute && !selectedEstate) {
      setModalVisible(true);
    } else {
      setModalVisible(false);
    }
  }, [location.pathname, selectedEstate, loading]);

  return (
    <>
      {children}
      <EstateSelectorModal visible={modalVisible} onClose={() => setModalVisible(false)} />
    </>
  );
};

export default RequireEstate;
